import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import "./index.css";
import Main from "./containers/Main";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Main} />
      </Switch>
    </Router>
  );
}

export default App;
